
  import { integrationsConfigService } from '@/services/integrations/integrationsConfigService';
  import { RequiredConfigVariable } from '@/services/integrations/types';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { Button } from '@/ui/components/Button';
  import BaseStep, { BaseStepProperties, BASE_STEP_PROPS } from './BaseStep.vue';
  import { computed, defineComponent, ref } from 'vue';

  interface AuthorizeConnectionStepProperties extends BaseStepProperties {
    configVariable: RequiredConfigVariable;
  }

  export default defineComponent<AuthorizeConnectionStepProperties>({
    components: {
      Button,
      BaseStep,
    },
    props: [...BASE_STEP_PROPS, 'configVariable'],

    setup() {
      const store = useIntegrationDetailsStore();
      const loading = ref(false);
      const connected = ref(false);
      const instance = computed(() => store.instance);

      const submit = () => {
        store.nextStep();
      };

      const CHECK_INTERVAL = 1000;
      let popup: Window | null;

      const startAuthentication = async () => {
        loading.value = true;
        const authorizeUrl = integrationsConfigService.getAuthorizeUrl(instance.value!);
        popup = window.open(authorizeUrl!, '', 'width=800, height=800');
        waitForConnection();
      };

      const waitForConnection = () => {
        setTimeout(checkConnection, CHECK_INTERVAL);
      };

      const checkConnection = async () => {
        const isConnected = await integrationsConfigService.checkSingleStepConnection(instance.value!);
        if (isConnected) {
          loading.value = false;
          connected.value = true;
        }

        if (popup?.closed) {
          loading.value = false;
        }

        if (loading.value) {
          setTimeout(checkConnection, CHECK_INTERVAL);
        }
      };

      return {
        instance,
        loading,
        connected,
        startAuthentication,
        submit,
      };
    },
  });
